export default __webpack_public_path__ + "static/media/popconfigonshopify.05a013b9.jpg";